import taskManagerApi from "@/features/shared/services/taskManagerApi";
export async function uploadProfilePhoto(file) {
    const formData = new FormData();
    formData.append("photo", file);
    try {
        const response = await taskManagerApi.post("/user/me/profile-photo", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        const data = response.data?.data;
        return data.profile_photo;
    }
    catch (error) {
        handleProfilePhotoError(error, "l'envoi de la photo de profil");
    }
}
export async function deleteProfilePhoto() {
    try {
        await taskManagerApi.delete("/user/me/profile-photo");
    }
    catch (error) {
        handleProfilePhotoError(error, "la suppression de la photo de profil");
    }
}
function handleProfilePhotoError(error, context) {
    if (error instanceof Error) {
        const serverError = error?.response?.data?.error;
        throw new Error(serverError?.details ?? serverError?.message ?? error.message);
    }
    throw new Error(`Erreur inconnue lors de ${context}`);
}
